// extracted by mini-css-extract-plugin
export default {"root":"_2wq-v","normal":"_3xvaM","tier-link":"x4jDT","tierLink":"x4jDT"};